var map = {
	"./home-entertainment.de-CH.json": 1432,
	"./home-entertainment.de-DE.json": 1433,
	"./home-entertainment.en-CA.json": 1434,
	"./home-entertainment.en-GB.json": 1435,
	"./home-entertainment.en-IN.json": 1436,
	"./home-entertainment.en-ME.json": 1437,
	"./home-entertainment.en-US.json": 1438,
	"./home-entertainment.es-EM.json": 1439,
	"./home-entertainment.es-ES.json": 1440,
	"./home-entertainment.fr-BE.json": 1441,
	"./home-entertainment.fr-CA.json": 1442,
	"./home-entertainment.fr-CH.json": 1443,
	"./home-entertainment.nl-BE.json": 1444,
	"./home-entertainment.nl-NL.json": 1445,
	"./home-entertainment.pl-PL.json": 1446,
	"./home-entertainment.pt-BR.json": 1447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1431;